import { TaskListProvider } from './Context'
import React from 'react'
import { List } from './List'
import type { TaskListProviderProps } from '@ztechapps/webui.contract'

export { TaskTable } from './List'
export { TaskListProvider } from './Context'

export type TaskListProps = Omit<TaskListProviderProps, 'children'>
export const TaskList = (props: TaskListProps) => {
  return (
    <TaskListProvider {...props}>
      <List />
    </TaskListProvider>
  )
}
